const DEFAULT_OVERLAY_CSS = {
  leftOverlay: {
    containerStyle: {
      backgroundColor: "#ffffff",
      fontSize: "12px",
      fontWeight: 600,
      top: "10px",
    },
    textStyle: {
      color: "#d56939",
      fontWeight: "600",
      fontSize: "14px",
    },
  },
  rightOverlay: {
    containerStyle: {
      backgroundColor: "#ffffff",
      fontSize: "12px",
      fontWeight: 600,
      top: "0px",
      right: "24px",
    },
    textStyle: {
      color: "#d56939",
    },
  },
};

const PUJA_SCROLL_RESPONSIVE = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
  },
};

const CHADHAVA_SUB_ADDON_SCROLL_RESPONSIVE = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
  },
};
export {
  DEFAULT_OVERLAY_CSS,
  PUJA_SCROLL_RESPONSIVE,
  CHADHAVA_SUB_ADDON_SCROLL_RESPONSIVE,
};
